import { Controller, useFormContext } from 'react-hook-form';

import useTranslation from '@/utils/hooks/translation/useTranslation';

//type
import type { PlatformFormType } from '@/components/pages/settings/platform/types';

//libs
import { enable_notifications } from '@/lib/settings/optionsConfiguration/platformSettings/platform-settings';

//components
import { SelectComponent } from '@/components/base/Select/SelectComponent/SelectComponent';

export function PlatformEnableNotifications() {
    const { t } = useTranslation('settings');

    const options = enable_notifications(t);

    const {
        control,
        formState: { errors }
    } = useFormContext<PlatformFormType>();

    return (
        <Controller
            key={'enable_notifications'}
            control={control}
            name={'enable_notifications'}
            render={({ field: { onChange, value } }) => {
                return (
                    <SelectComponent
                        selected={options?.find((item) => value['value'] === item.value)}
                        setSelected={onChange}
                        label={t('platform_page.enable_notifications')}
                        error={errors.enable_notifications?.message}
                        options={options}
                    />
                );
            }}
        />
    );
}
